import React, { FC } from 'react';
import Image from 'next/image';
import HeaderText, { HeaderSize } from '@/components/ui/HeaderText/HeaderText';

import { TypeSocialProofEditorialItemFields } from '@/core/generated-types';
import { Card } from '../../SocialProof';

const EditorialItem: FC<TypeSocialProofEditorialItemFields> = ({
  title,
  asset,
  description,
  breakAfter,
}) => {
  return (
    <Card
      classes={`p-4 md:p-[2vw] flex flex-col ${breakAfter ? 'break-after-column' : ''}`}
    >
      <div className="flex flex-row mb-4 items-end justify-between">
        <HeaderText
          size={HeaderSize.H3}
          classes="leading-5 font-bold"
          text={title}
          hoverEffect
        />
        {asset && (
          <Image
            className="w-1/3 max-w-[45px] h-full md:max-w-none"
            src={`https:${asset.fields.file?.url}`}
            width={100}
            height={50}
            alt={title ?? ''}
          />
        )}
      </div>

      <p className="text-[13px] leading-5 md:text-base">{description}</p>
    </Card>
  );
};

export default EditorialItem;
